import { render, staticRenderFns } from "./v2Chat.vue?vue&type=template&id=2e3b3cbf&scoped=true"
import script from "./v2Chat.vue?vue&type=script&lang=js"
export * from "./v2Chat.vue?vue&type=script&lang=js"
import style0 from "./v2Chat.vue?vue&type=style&index=0&id=2e3b3cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b3cbf",
  null
  
)

export default component.exports